export const FIRST_NAMES = [
  'John',
  'Emily',
  'Sarah',
  'Michael',
  'Emma',
  'Oliver',
  'Sophia',
  'Liam',
  'Ava',
  'Noah',
  'Isabella',
  'James',
  'Mia',
  'Benjamin',
  'Charlotte',
  'Lucas',
  'Amelia',
  'Ethan',
  'Harper',
  'Alexander',
  'Evelyn',
  'Sebastian',
  'Victoria',
  'Mason',
  'Ella',
  'William',
  'Daniel',
  'Valentina',
  'Carlos',
  'María',
  'Antonio',
  'Laura',
  'Pablo',
  'Ana',
  'Diego',
  'Carmen',
] as const;

export const LAST_NAMES = [
  'Johnson',
  'Smith',
  'Davis',
  'Brown',
  'Wilson',
  'Taylor',
  'Anderson',
  'Martinez',
  'Garcia',
  'Rodriguez',
  'Lopez',
  'Hernandez',
  'Gonzalez',
  'Perez',
  'Sanchez',
  'Ramirez',
  'Torres',
  'Rivera',
  'Flores',
  'Baker',
  'Reed',
  'Morgan',
  'Cooper',
  'Bailey',
  'Scott',
  'Green',
  'Adams',
  'Wright',
  'Hall',
  'Young',
  'King',
  'Harris',
  'Lewis',
  'Walker',
] as const;

export const DOC_TYPES = ['NIF', 'NIE', 'PASSPORT', 'DNI'] as const;

export const KINSHIPS = ['SPOUSE', 'CHILD', 'PARENT', 'SIBLING', 'FRIEND', 'OTHER'] as const;

export const RENTAL_ADJECTIVES = [
  'Cozy',
  'Luxury',
  'Modern',
  'Charming',
  'Sunny',
  'Elegant',
  'Rustic',
  'Spacious',
  'Premium',
  'Beautiful',
  'Stunning',
  'Peaceful',
  'Bright',
] as const;

export const RENTAL_PLACES = [
  'Beach',
  'Mountain',
  'Lake',
  'City',
  'Forest',
  'Seaside',
  'Countryside',
  'Coastal',
  'Downtown',
  'Hilltop',
  'Garden',
  'Riverside',
  'Harbor',
] as const;

export const RENTAL_DWELLING_TYPES = [
  'House',
  'Apartment',
  'Villa',
  'Cabin',
  'Loft',
  'Studio',
  'Cottage',
  'Penthouse',
  'Bungalow',
  'Chalet',
] as const;

export const RENTAL_DESCRIPTIONS = [
  'A beautiful property with stunning views and modern amenities.',
  'Perfect getaway for families and couples. Recently renovated.',
  'Enjoy the tranquility and charm of this well-equipped retreat.',
  'Ideally located property with easy access to local attractions.',
  'Spacious and comfortable, with all the amenities you need.',
  'A hidden gem surrounded by nature, yet close to everything.',
] as const;

export const RENTAL_SHORT_DESCRIPTIONS = [
  'Stunning views, modern comfort.',
  'Perfect family getaway.',
  'Tranquil retreat with charm.',
  'Great location, fully equipped.',
  'Spacious and comfortable stay.',
  'Hidden gem in nature.',
] as const;

export const BOOKING_STATUSES = [
  'ACCEPTANCE_PENDING',
  'PAYMENT_PENDING',
  'SUSPENDED_PAYMENT_PENDING',
  'GUEST_MIR_DATA_PENDING',
  'SEND_GUEST_MIR_DATA_PENDING',
  'SUSPENDED_GUEST_MIR_DATA_PENDING',
  'BOOKING_NOTIFICATION_PENDING',
  'BOOKING_NOTIFICATION_ERROR',
  'SUSPENDED_BOOKING_NOTIFICATION_ERROR',
  'BOOKING_NOTIFICATION_TIMEOUT',
  'CHECKIN_PENDING',
  'CHECKIN_ERROR',
  'CHECKIN_NOTIFICATION_TIMEOUT',
  'CHECKOUT_PENDING',
  'CHECKOUT_HOST_CONFIRMATION_PENDING',
  'BOOKING_CHECKOUT_ERROR',
  'FINISHED',
  'BOOKING_CANCELLED',
  'ACCEPTANCE_CANCELED',
  'ACCEPTANCE_CANCELLED',
  'ACCEPTANCE_TIMEOUT',
  'PAYMENT_TIMEOUT',
  'GUEST_MIR_DATA_TIMEOUT',
] as const;

export const ACTIVE_STATUSES = [
  'CHECKIN_PENDING',
  'CHECKOUT_PENDING',
  'CHECKOUT_HOST_CONFIRMATION_PENDING',
] as const;

export const PENDING_STATUSES = [
  'ACCEPTANCE_PENDING',
  'PAYMENT_PENDING',
  'SUSPENDED_PAYMENT_PENDING',
  'GUEST_MIR_DATA_PENDING',
  'SUSPENDED_GUEST_MIR_DATA_PENDING',
  'BOOKING_NOTIFICATION_ERROR',
  'SUSPENDED_BOOKING_NOTIFICATION_ERROR',
  'CHECKIN_ERROR',
] as const;

export const CONFIRMED_STATUSES = ['BOOKING_NOTIFICATION_PENDING'] as const;

export const FINISHED_STATUSES = ['FINISHED'] as const;

export const CANCELLED_STATUSES = [
  'BOOKING_CANCELLED',
  'ACCEPTANCE_CANCELED',
  'ACCEPTANCE_CANCELLED',
] as const;

export const ERROR_STATUSES = [
  'ACCEPTANCE_TIMEOUT',
  'PAYMENT_TIMEOUT',
  'GUEST_MIR_DATA_TIMEOUT',
  'BOOKING_NOTIFICATION_TIMEOUT',
  'CHECKIN_NOTIFICATION_TIMEOUT',
  'BOOKING_CHECKOUT_ERROR',
] as const;

export const BOOKING_CHANNELS = ['SSR', 'FEONDI'] as const;

export const BOOKING_TYPES = ['STANDARD', 'INSTANT', 'REQUEST'] as const;

export const CANCELLATION_POLICIES = ['NONE', 'FLEXIBLE', 'MODERATE', 'STRICT'] as const;

export const CHECK_IN_STATUSES = ['PENDING', 'IN_PROGRESS', 'COMPLETED'] as const;

export const LOCALES = ['es', 'en', 'de', 'pt'] as const;

export const CURRENCIES = ['EUR', 'USD', 'GBP'] as const;

export const PAYMENT_GATEWAYS = ['REDSYS', 'STRIPE', 'PAYPAL'] as const;

export const STREET_NAMES = [
  'Calle Mayor',
  'Av. de la Playa',
  'Paseo Marítimo',
  'Calle del Sol',
  'Av. de la Constitución',
  'Calle Luna',
  'Paseo de Gracia',
  'Gran Vía',
  'Rambla de Catalunya',
  'Calle del Mar',
  'Calle de la Paz',
  'Av. del Puerto',
] as const;

export const ZIP_CODES = [
  '08001',
  '28001',
  '46001',
  '29001',
  '41001',
  '18001',
  '04001',
  '11001',
  '29601',
  '08820',
  '03001',
  '07001',
] as const;

export const COUNTRY_DATA: readonly { id: string; name: string }[] = [
  { id: 'ES', name: 'Spain' },
  { id: 'FR', name: 'France' },
  { id: 'PT', name: 'Portugal' },
  { id: 'IT', name: 'Italy' },
  { id: 'DE', name: 'Germany' },
];

export const PROVINCE_DATA: readonly { id: string; name: string }[] = [
  { id: 'B', name: 'Barcelona' },
  { id: 'M', name: 'Madrid' },
  { id: 'V', name: 'Valencia' },
  { id: 'GR', name: 'Granada' },
  { id: 'ML', name: 'Málaga' },
  { id: 'SE', name: 'Sevilla' },
];

export const CITY_DATA: readonly {
  id: number;
  name: string;
  municipalityCode: number;
  provinceCode: string;
}[] = [
  { id: 1, name: 'Madrid', municipalityCode: 28001, provinceCode: 'M' },
  { id: 2, name: 'Barcelona', municipalityCode: 8001, provinceCode: 'B' },
  { id: 3, name: 'Valencia', municipalityCode: 46001, provinceCode: 'V' },
  { id: 4, name: 'Málaga', municipalityCode: 29001, provinceCode: 'ML' },
  { id: 5, name: 'Granada', municipalityCode: 18001, provinceCode: 'GR' },
  { id: 6, name: 'Badalona', municipalityCode: 8820, provinceCode: 'B' },
  { id: 7, name: 'Sevilla', municipalityCode: 41001, provinceCode: 'SE' },
  { id: 8, name: "L'Hospitalet de Llobregat", municipalityCode: 8900, provinceCode: 'B' },
];

export const LOCATION_NAMES = [
  'Main Office',
  'Beach Office',
  'Mountain Retreat',
  'City Center',
  'Seaside Villa',
  'Lakefront Property',
  'Downtown Loft',
  'Country Estate',
] as const;

export const LOCK_DEVICE_NAMES = [
  'Front Door Lock',
  'Back Door Lock',
  'Garage Lock',
  'Gate Lock',
  'Side Door Lock',
  'Terrace Lock',
  'Pool Gate Lock',
] as const;

export const LOCK_TYPES = ['smart', 'keypad', 'rfid', 'bluetooth'] as const;

export const LOCK_ACCESS_METHODS = ['passcode', 'fingerprint', 'card', 'app', 'key'] as const;

export const LOCK_ACTIVITIES = [
  'Opened main door',
  'Opened garage',
  'Opened back door',
  'Opened terrace',
  'Opened gate',
  'Opened pool gate',
] as const;

export const SPACE_TYPE_DATA: readonly { name: string; description: string }[] = [
  { name: 'Living', description: 'Living area' },
  { name: 'Bedroom', description: 'Sleeping area' },
  { name: 'Bathroom', description: 'Bathroom area' },
  { name: 'Kitchen', description: 'Kitchen area' },
  { name: 'Terrace', description: 'Outdoor terrace' },
];

export const SPACE_NAMES = [
  'Salón Principal',
  'Habitación Suite',
  'Habitación Doble',
  'Baño Principal',
  'Cocina',
  'Terraza',
  'Estudio',
  'Habitación Individual',
  'Baño Secundario',
  'Sala de Estar',
] as const;

export const AMENITY_POOL: Record<string, { names: string[]; icon: string }> = {
  parking: {
    names: [
      'Free Parking',
      'Garage',
      'Street Parking',
      'EV Charging Station',
      'Bike Storage',
      'Accessible Parking',
    ],
    icon: 'pi pi-car',
  },
  climate: {
    names: [
      'Air Conditioning',
      'Central Heating',
      'Ceiling Fans',
      'Portable Heater',
      'Fireplace',
      'Underfloor Heating',
    ],
    icon: 'pi pi-sun',
  },
  entertainment: {
    names: [
      'Smart TV',
      'High-Speed WiFi',
      'Gaming Console',
      'Board Games',
      'Bluetooth Speaker',
      'Projector',
    ],
    icon: 'pi pi-desktop',
  },
  bathroom: {
    names: ['Hot Water', 'Bathtub', 'Rain Shower', 'Hair Dryer', 'Fresh Towels', 'Toiletries Kit'],
    icon: 'pi pi-inbox',
  },
  kitchen: {
    names: [
      'Full Kitchen',
      'Refrigerator',
      'Dishwasher',
      'Oven',
      'Microwave',
      'Coffee Maker',
      'Cooking Utensils',
    ],
    icon: 'pi pi-shopping-bag',
  },
  security: {
    names: [
      'Smart Lock',
      'In-Room Safe',
      'CCTV Surveillance',
      'Alarm System',
      'Building Access Card',
      '24/7 Concierge',
    ],
    icon: 'pi pi-lock',
  },
  safety: {
    names: [
      'Smoke Detector',
      'Carbon Monoxide Detector',
      'Fire Extinguisher',
      'First Aid Kit',
      'Emergency Exit Plan',
      'Fire Blanket',
    ],
    icon: 'pi pi-shield',
  },
  health: {
    names: ['Gym Access', 'Swimming Pool', 'Yoga Mat', 'Sauna', 'Jacuzzi', 'Baby Cot'],
    icon: 'pi pi-heart',
  },
  conditions: {
    names: [
      'Wheelchair Accessible',
      'Elevator Access',
      'Ground Floor Unit',
      'Wide Doorways',
      'Roll-in Shower',
      'Accessible Parking Space',
    ],
    icon: 'pi pi-users',
  },
  other: {
    names: [
      'Washer/Dryer',
      'Iron & Board',
      'Dedicated Workspace',
      'Luggage Storage',
      'Pet Friendly',
      'Private Balcony',
    ],
    icon: 'pi pi-ellipsis-h',
  },
  policies: {
    names: [
      'No Smoking',
      'No Pets Allowed',
      'No Parties/Events',
      'Quiet Hours (22:00-08:00)',
      'No Unregistered Guests',
      'ID Check Required',
    ],
    icon: 'pi pi-file',
  },
};

export const HOST_NAMES = [
  'Mojacar Dream',
  'Costa Blanca Rentals',
  'Sierra Nevada Lodge',
  'Barcelona Stay',
  'Andalucia Villas',
  'Mediterranean Haven',
] as const;

export const TIMEZONES = ['Europe/Madrid', 'Europe/Paris', 'Europe/Lisbon'] as const;

export const RENTAL_TYPE_DATA: readonly { id: string; name: string }[] = [
  { id: 'type-premium', name: 'Premium' },
  { id: 'type-standard', name: 'Standard' },
  { id: 'type-economy', name: 'Economy' },
];
